export const LISTENING_TEST_LENGTH = 10
const HISTORY_KEY = 'gs.listeningQuestionHistory.v2'

export function readRecentQuestions(storage) {
  try {
    storage = storage || window.localStorage
    const value = JSON.parse(storage.getItem(HISTORY_KEY) || '[]')
    return Array.isArray(value) ? value.filter(id => typeof id === 'string').slice(-100) : []
  } catch { return [] }
}

export function rememberQuestions(ids, storage) {
  try {
    storage = storage || window.localStorage
    storage.setItem(HISTORY_KEY, JSON.stringify([...readRecentQuestions(storage), ...ids].slice(-100)))
  } catch { /* 浏览器禁止存储时，本次测试仍可进行。 */ }
}

export function startListeningTest(items) {
  if (items.length !== LISTENING_TEST_LENGTH || new Set(items.map(item => item.id)).size !== LISTENING_TEST_LENGTH ||
      items.filter(item => item.type === 'choice').length !== 6 || items.filter(item => item.type === 'dictation').length !== 4) {
    throw new Error('Listening test requires six choices and four dictations')
  }
  return { answers: [] }
}

export function recordListeningAnswer(state, items, response, plays) {
  if (state.answers.length >= LISTENING_TEST_LENGTH) return state
  const item = items[state.answers.length]
  if (typeof response !== 'string' || response.length > 500 ||
      (item.type === 'choice' && response && !item.options.includes(response))) {
    throw new Error('Invalid listening answer')
  }
  return { answers: [...state.answers, { itemId: item.id, response: response.trim(), plays }] }
}
